export const NAME = 'videoService';
